import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Initialize data
export const initializeData = () => axios.post(`${API}/init-data`);

// Dashboard
export const getDashboardStats = () => axios.get(`${API}/dashboard/stats`);

// Users
export const getUsers = () => axios.get(`${API}/users`);
export const getUser = (id) => axios.get(`${API}/users/${id}`);
export const createUser = (data) => axios.post(`${API}/users`, data);
export const updateUser = (id, data) => axios.put(`${API}/users/${id}`, data);
export const deleteUser = (id) => axios.delete(`${API}/users/${id}`);

// Roles
export const getRoles = () => axios.get(`${API}/roles`);
export const createRole = (data) => axios.post(`${API}/roles`, data);
export const updateRole = (id, data) => axios.put(`${API}/roles/${id}`, data);
export const deleteRole = (id) => axios.delete(`${API}/roles/${id}`);

// Messages
export const getMessages = () => axios.get(`${API}/messages`);
export const getConversation = (userId) => axios.get(`${API}/messages/conversation/${userId}`);
export const sendMessage = (data) => axios.post(`${API}/messages`, data);
export const markMessageRead = (id) => axios.put(`${API}/messages/${id}/read`);

// Announcements
export const getAnnouncements = () => axios.get(`${API}/announcements`);
export const createAnnouncement = (data) => axios.post(`${API}/announcements`, data);
export const updateAnnouncement = (id, data) => axios.put(`${API}/announcements/${id}`, data);
export const deleteAnnouncement = (id) => axios.delete(`${API}/announcements/${id}`);
export const reactToAnnouncement = (id, emoji) => axios.post(`${API}/announcements/${id}/react`, { emoji });
export const reactToNoticiaPublic = (id, emoji) => axios.post(`${API}/public/noticias/${id}/react`, { emoji });

// Events
export const getEvents = () => axios.get(`${API}/events`);
export const createEvent = (data) => axios.post(`${API}/events`, data);
export const updateEvent = (id, data) => axios.put(`${API}/events/${id}`, data);
export const deleteEvent = (id) => axios.delete(`${API}/events/${id}`);

// Inventory
export const getInventory = () => axios.get(`${API}/inventory`);
export const createInventoryItem = (data) => axios.post(`${API}/inventory`, data);
export const updateInventoryItem = (id, data) => axios.put(`${API}/inventory/${id}`, data);
export const deleteInventoryItem = (id) => axios.delete(`${API}/inventory/${id}`);

// Finance
export const getFinanceRecords = () => axios.get(`${API}/finance`);
export const getFinanceSummary = () => axios.get(`${API}/finance/summary`);
export const createFinanceRecord = (data) => axios.post(`${API}/finance`, data);
export const deleteFinanceRecord = (id) => axios.delete(`${API}/finance/${id}`);

// Budgets
export const getBudgets = () => axios.get(`${API}/budgets`);
export const createBudget = (data) => axios.post(`${API}/budgets`, data);
export const updateBudget = (id, data) => axios.put(`${API}/budgets/${id}`, data);
export const addBudgetExpense = (id, amount) => axios.put(`${API}/budgets/${id}/spend?amount=${amount}`);
export const deleteBudget = (id) => axios.delete(`${API}/budgets/${id}`);

// Surveys
export const getSurveys = () => axios.get(`${API}/surveys`);
export const createSurvey = (data) => axios.post(`${API}/surveys`, data);
export const respondToSurvey = (id, data) => axios.post(`${API}/surveys/${id}/respond`, data);
export const getSurveyResponses = (id) => axios.get(`${API}/surveys/${id}/responses`);
export const deleteSurvey = (id) => axios.delete(`${API}/surveys/${id}`);

// Documents
export const getDocuments = (category) => {
  const url = category ? `${API}/documents?category=${category}` : `${API}/documents`;
  return axios.get(url);
};
export const createDocument = (data) => axios.post(`${API}/documents`, data);
export const uploadDocument = (formData, params) => {
  const url = `${API}/documents/upload?name=${encodeURIComponent(params.name)}&category=${encodeURIComponent(params.category)}${params.description ? `&description=${encodeURIComponent(params.description)}` : ''}`;
  return axios.post(url, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};
export const downloadDocument = (id) => axios.get(`${API}/documents/${id}/download`);
export const deleteDocument = (id) => axios.delete(`${API}/documents/${id}`);

// Groups
export const getGroups = () => axios.get(`${API}/groups`);
export const createGroup = (data) => axios.post(`${API}/groups`, data);
export const updateGroup = (id, data) => axios.put(`${API}/groups/${id}`, data);
export const deleteGroup = (id) => axios.delete(`${API}/groups/${id}`);

// Attendance
export const getEventAttendance = (eventId) => axios.get(`${API}/attendance/event/${eventId}`);
export const initEventAttendance = (eventId) => axios.post(`${API}/attendance/event/${eventId}/init`);
export const updateAttendance = (recordId, status, notes) => {
  let url = `${API}/attendance/${recordId}?status=${status}`;
  if (notes) url += `&notes=${encodeURIComponent(notes)}`;
  return axios.put(url);
};
export const bulkUpdateAttendance = (eventId, userIds, status) => {
  const params = new URLSearchParams();
  params.append('event_id', eventId);
  userIds.forEach(id => params.append('user_ids', id));
  params.append('status', status);
  return axios.post(`${API}/attendance/bulk-update?${params.toString()}`);
};
export const getUserAttendanceStats = (userId) => axios.get(`${API}/attendance/stats/user/${userId}`);
export const getEventAttendanceStats = (eventId) => axios.get(`${API}/attendance/stats/event/${eventId}`);

// Notifications
export const getNotifications = () => axios.get(`${API}/notifications`);
export const createNotification = (data) => axios.post(`${API}/notifications`, data);
export const markNotificationRead = (id) => axios.put(`${API}/notifications/${id}/read`);
export const markAllNotificationsRead = () => axios.put(`${API}/notifications/read-all`);
export const deleteNotification = (id) => axios.delete(`${API}/notifications/${id}`);

// Recurring Events
export const getRecurringEvents = () => axios.get(`${API}/recurring-events`);
export const createRecurringEvent = (data) => axios.post(`${API}/recurring-events`, data);
export const updateRecurringEvent = (id, data) => axios.put(`${API}/recurring-events/${id}`, data);
export const deleteRecurringEvent = (id) => axios.delete(`${API}/recurring-events/${id}`);
export const generateRecurringEvents = (id, weeks = 4) => axios.post(`${API}/recurring-events/${id}/generate?weeks=${weeks}`);

// Branding
export const getBranding = () => axios.get(`${API}/branding`);
export const updateBranding = (data) => axios.put(`${API}/branding`, data);

// System Settings
export const getSystemSettings = () => axios.get(`${API}/settings/system`);
export const updateSystemSettings = (data) => axios.put(`${API}/settings/system`, data);
export const getAllSettings = () => axios.get(`${API}/settings/all`);

// Event Types
export const getEventTypes = () => axios.get(`${API}/event-types`);
export const createEventType = (data) => axios.post(`${API}/event-types`, data);
export const deleteEventType = (id) => axios.delete(`${API}/event-types/${id}`);

// Birthdays
export const getTodaysBirthdays = () => axios.get(`${API}/birthdays/today`);
export const getUpcomingBirthdays = (days = 30) => axios.get(`${API}/birthdays/upcoming?days=${days}`);

// Permission Modules
export const getModules = () => axios.get(`${API}/roles/modules`);

// Dynamic Fields
export const getDynamicFields = (modulo) => {
  const url = modulo ? `${API}/dynamic-fields?modulo=${modulo}` : `${API}/dynamic-fields`;
  return axios.get(url);
};
export const getAllDynamicFields = () => axios.get(`${API}/dynamic-fields/all`);
export const createDynamicField = (data) => axios.post(`${API}/dynamic-fields`, data);
export const updateDynamicField = (id, data) => axios.put(`${API}/dynamic-fields/${id}`, data);
export const deleteDynamicField = (id) => axios.delete(`${API}/dynamic-fields/${id}`);

// Audit Log
export const getAuditLog = (params) => axios.get(`${API}/audit`, { params });

// Cuotas
export const getCuotaConfigs = () => axios.get(`${API}/cuotas/config`);
export const createCuotaConfig = (data) => axios.post(`${API}/cuotas/config`, data);
export const updateCuotaConfig = (id, data) => axios.put(`${API}/cuotas/config/${id}`, data);
export const deleteCuotaConfig = (id) => axios.delete(`${API}/cuotas/config/${id}`);
export const generateCuotas = (configId, periodo) => axios.post(`${API}/cuotas/generate?config_id=${configId}&periodo=${periodo}`);
export const getCuotas = (params) => axios.get(`${API}/cuotas`, { params });
export const updateCuotaPago = (id, data) => axios.put(`${API}/cuotas/${id}`, data);
export const deleteCuota = (id) => axios.delete(`${API}/cuotas/${id}`);
export const getCuotasSummary = (periodo) => {
  const url = periodo ? `${API}/cuotas/summary?periodo=${periodo}` : `${API}/cuotas/summary`;
  return axios.get(url);
};
export const getMorosos = () => axios.get(`${API}/cuotas/morosos`);

// Tasks
export const getTasks = (params) => axios.get(`${API}/tasks`, { params });
export const createTask = (data) => axios.post(`${API}/tasks`, data);
export const updateTask = (id, data) => axios.put(`${API}/tasks/${id}`, data);
export const moveTask = (id, estado) => axios.put(`${API}/tasks/${id}/move?estado=${estado}`);
export const deleteTask = (id) => axios.delete(`${API}/tasks/${id}`);
export const getTaskStats = () => axios.get(`${API}/tasks/stats`);

// Sponsor Portal
export const getSponsorDashboard = () => axios.get(`${API}/sponsor/dashboard`);
export const getSponsorContacts = () => axios.get(`${API}/sponsor/contacts`);

// Automations
export const getAutomations = () => axios.get(`${API}/automations`);
export const createAutomation = (data) => axios.post(`${API}/automations`, data);
export const updateAutomation = (id, data) => axios.put(`${API}/automations/${id}`, data);
export const deleteAutomation = (id) => axios.delete(`${API}/automations/${id}`);
export const executeAutomation = (id) => axios.post(`${API}/automations/${id}/execute`);
export const getAutomationLog = () => axios.get(`${API}/automations/log`);
export const getAutomationStats = () => axios.get(`${API}/automations/stats`);

// Inventory Loans
export const getLoans = (params) => axios.get(`${API}/inventory/loans`, { params });
export const createLoan = (itemId, userId, notas) => axios.post(`${API}/inventory/loans?item_id=${itemId}&user_id=${userId}&notas=${encodeURIComponent(notas || '')}`);
export const returnLoan = (loanId, notas) => axios.put(`${API}/inventory/loans/${loanId}/return?notas=${encodeURIComponent(notas || '')}`);

// Export CSV
export const exportFinance = () => axios.get(`${API}/export/finance`, { responseType: 'blob' });
export const exportCuotas = (periodo) => {
  const url = periodo ? `${API}/export/cuotas?periodo=${periodo}` : `${API}/export/cuotas`;
  return axios.get(url, { responseType: 'blob' });
};
export const exportUsers = () => axios.get(`${API}/export/users`, { responseType: 'blob' });
export const exportInventory = () => axios.get(`${API}/export/inventory`, { responseType: 'blob' });
export const exportAudit = () => axios.get(`${API}/export/audit`, { responseType: 'blob' });

// Push Notifications
export const getVapidKey = () => axios.get(`${API}/push/vapid-public-key`);
export const subscribePush = (sub) => axios.post(`${API}/push/subscribe`, sub);
export const unsubscribePush = () => axios.delete(`${API}/push/unsubscribe`);

// Presupuestos
export const getPresupuestos = () => axios.get(`${API}/presupuestos`);
export const createPresupuesto = (data) => axios.post(`${API}/presupuestos`, data);
export const getPresupuesto = (id) => axios.get(`${API}/presupuestos/${id}`);
export const updatePresupuesto = (id, data) => axios.put(`${API}/presupuestos/${id}`, data);
export const deletePresupuesto = (id) => axios.delete(`${API}/presupuestos/${id}`);
export const calcularCuotasPresupuesto = (id) => axios.post(`${API}/presupuestos/${id}/calcular`);
export const confirmarPresupuesto = (id) => axios.post(`${API}/presupuestos/${id}/confirmar`);
export const cerrarPresupuesto = (id) => axios.post(`${API}/presupuestos/${id}/cerrar`);
export const getPresupuestoCuotas = (id) => axios.get(`${API}/presupuestos/${id}/cuotas`);
export const seleccionarPago = (presId, userId, data) => axios.post(`${API}/presupuestos/${presId}/cuotas/${userId}/seleccionar-pago`, data);
export const confirmarPago = (presId, userId, data) => axios.post(`${API}/presupuestos/${presId}/cuotas/${userId}/confirmar-pago`, data);
export const confirmarPagosMultiples = (presId, data) => axios.post(`${API}/presupuestos/${presId}/cuotas/confirmar-multiples`, data);
export const sendRecordatorio = (id) => axios.post(`${API}/presupuestos/${id}/recordatorio`);
export const getBizumConfig = () => axios.get(`${API}/presupuestos/config/bizum`);
export const updateBizumConfig = (data) => axios.put(`${API}/presupuestos/config/bizum`, data);

// Homepage Admin
export const getHomepageSettings = () => axios.get(`${API}/settings/homepage`);
export const updateHomepageSettings = (data) => axios.put(`${API}/settings/homepage`, data);

// File Uploads
export const uploadImage = (file, context = 'general') => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API}/uploads/image?context=${context}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};
export const uploadMedia = (file, context = 'general') => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API}/uploads/media?context=${context}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};
export const uploadAvatar = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API}/uploads/avatar`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};